import logoUrl from '@/assets/afterbooking-logo.svg';

export interface LogoProps {
  /** Tailwind size classes applied to the wordmark image. */
  className?: string;
}

/**
 * AfterBooking brand wordmark (midnight "After" + amber "Booking").
 */
export function Logo({ className = 'h-7 w-auto' }: LogoProps) {
  return <img src={logoUrl} alt="AfterBooking" className={className} />;
}
